import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Technologies from "@/pages/Technologies";
import TechDetail from "@/pages/TechDetail";
import OEM from "@/pages/OEM";
import ODM from "@/pages/ODM";
import Industries from "@/pages/Industries";
import Company from "@/pages/Company";
import Downloads from "@/pages/Downloads";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import CookieConsent from "@/components/CookieConsent";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-white">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/technologies" element={<Technologies />} />
            <Route path="/technologies/:slug" element={<TechDetail />} />
            <Route path="/oem" element={<OEM />} />
            <Route path="/odm" element={<ODM />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/company" element={<Company />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
